import { useAmplitudeEvents } from '@/utils/amplitudeEvents';
import { buildSearchQuery, type SubmitPayload } from '@/utils/searchUrl';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useSearchSubmit = () => {
  const navigate = useNavigate();
  const { trackSearchCompleted } = useAmplitudeEvents();

  const submit = useCallback(
    (payload: SubmitPayload) => {
      trackSearchCompleted(payload.checkIn, payload.checkOut, payload.guests);

      const qs = buildSearchQuery(payload);
      navigate(qs ? `/search?${qs}` : '/search');
    },
    [navigate, trackSearchCompleted],
  );

  return { submit };
};
